// Simple logger utility for debugging
export const Logger = {
  debug(message: string, ...args: unknown[]): void {
    if (typeof window !== "undefined" && window.localStorage?.getItem("debug") === "true") {
      console.debug(`[VirtualScroll] ${message}`, ...args);
    }
  },

  warn(message: string, ...args: unknown[]): void {
    console.warn(`[VirtualScroll] ${message}`, ...args);
  },

  error(message: string, ...args: unknown[]): void {
    console.error(`[VirtualScroll] ${message}`, ...args);
  },
};
